<template>
	<div>
		<div>
			<!-- <Tag v-for="item in count" :key="item" :name="item" closable @on-close="handleClose2">标签{{ item + 1 }}</Tag>
			<Input search enter-button placeholder="Enter something..." />
			<Button icon="ios-add" type="dashed" size="small" @click="handleAdd">添加条件</Button> -->
			<Button type="primary" icon="ios-search" @click="searchByConditionsView">搜索</Button>
			<Button type="primary" style="margin-left: 20px" @click="getValvesNo(),showDown = true">数据下发</Button>
		</div>

		<Table size="large" border stripe :loading="loading" :columns="columns1" :data="data1" style="margin: 20px 0;">
			<template slot-scope="{ row, index }" slot="action">
				<Button type="primary" shape="circle" icon="ios-apps" @click="showData(row, index)"></Button>
			</template>
			<template slot-scope="{ row, index }" slot="status">
				<!-- <Button type="primary" size="small" style="margin-right: 5px"
					@click="updateDownMessage(row)">下发</Button> -->

				<!-- <Button v-if="row.messageDirection == 'down' && row.messageRemark1 == -10" type="primary" size="small"
					style="margin-right: 5px;" @click="updateDownMessage(row)">下发</Button> -->
				<label v-if="
                    row.mainType != 'paramSet'">已存储</label>
				<label v-if="
                    row.mainType == 'paramSet' && row.state == 0
                  ">待下发</label>
				<label v-if="
                    row.mainType == 'paramSet' && row.state == 1
                  ">已下发待响应</label>
				<label v-if="
                    row.mainType == 'paramSet' && row.state == 2
                  ">下发完成</label>
				<label v-if="
                    row.mainType == 'paramSet' && row.state == -100
                  ">下发失败</label>
				<!-- <label v-if="row.messageDirection == 'down' && row.messageRemark1 == -11">取消下发</label> -->
			</template>
		</Table>
		<Page :current="pageNo" :total="totalRows" :page-size="pageSize" :page-size-opts="[5, 10, 20, 30, 40]"
			show-sizer show-total @on-change="changePage" @on-page-size-change="changePageSize" />

		<Modal title="Title" v-model="showDown" :mask-closable="false" width="800">
			<p slot="header" style="color:#0066FF;text-align:center">
				<span>数据下发</span>
			</p>
			<div style="text-align:center">
				<Steps :current="currentDownStep" size="small">
					<Step title="选择设备"></Step>
					<Step title="填写参数"></Step>
					<!-- <Step title="确认下发"></Step> -->
				</Steps>
				<Divider></Divider>
				<div v-if="currentDownStep == 0">
					<Row>
						<Col span="7">
              <div style="height: 40px">
                <el-input @input="handleCurrentChange(1)" v-model="filterValve" size="small" />
              </div>
              <el-table height="560px" ref="multipleTable" :data="tableDate" :row-key="row => row.num" tooltip-effect="dark" style="width: 100%" @selection-change="selectValve">
                <el-table-column type="selection" width="55" :reserve-selection="true" />
                <el-table-column prop="num" label="设备编号"/>
              </el-table>
              <el-pagination
                  background
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="visibleDialog.currentPage"
                  :page-sizes="[15, 30, 50, 100, 200, 300, 400]"
                  :page-size="visibleDialog.pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="valvesNo.length"/>
<!--						<Select transfer filterable v-model="selectedValve">-->
<!--							<Option v-for="item in valvesNo" :value="item.mac" :key="item.mac">{{ item.num }}</Option>-->
<!--						</Select>-->
						</Col>
            <Col span="17">
              <div style="height: 600px; overflow-y: scroll">
                <Tag v-for="item in selectValveArray" style="left: 0px;" type="border" closable color="primary"
                     @on-close="handleClose(item)">{{item.mac}}</Tag>
              </div>
            </Col>
<!--						<Col span="6">-->
<!--						<Button type="primary" @click="selectValve">添加至列表</Button>-->
<!--						</Col>-->
					</Row>
<!--					<Divider></Divider>-->
<!--					<Row>-->
<!--						<Tag v-for="item in selectValveArray" style="left: 0px;" type="border" closable color="primary"-->
<!--							@on-close="handleClose(item)">{{item}}</Tag>-->
<!--					</Row>-->
				</div>
				<div v-if="currentDownStep == 1">
					<div class="layout">
						<Layout>
							<Layout>
								<Content :style="{background: '#fff'}">
									<Layout>
										<Sider hide-trigger :style="{background: '#fff'}" class="param-menu">
											<Menu active-name="1-2" theme="light" width="auto" @on-select="gotoContent">
												<MenuItem v-for="(profile, profileName) in valveProfile['paramSet']"
													:name="profileName">{{profile.cn}}<br />{{profileName}}
												</MenuItem>
											</Menu>
										</Sider>
										<Content :style="{'padding-left': '10px', background: '#fff'}"
											v-if="currentProfileName != ''">
											<Row>
												<Col span="8">
												<Select transfer filterable v-model="selectedDownValve">
													<Option v-for="item in selectValveArray" :value="item" :key="item">
														{{ valvesEnum[item] }}
													</Option>
												</Select>
												</Col>
												<Col span="8">
												<Button type="primary"
													@click="reloadDown(currentProfileName)">载入历史下发数据</Button>
												</Col>
												<Col span="8">
												<Button type="primary" @click="nextStep(currentProfileName)">下发</Button>
												</Col>
											</Row>
											<Divider></Divider>
											<div class="param-content">
												<v-row
													v-for="(value, key) in valveProfile['paramSet'][currentProfileName].params"
													:key="key" class="mx-4 my-2">
													<span style="width: 100%;text-align: left">
														<span
															:name="value.cn == undefined?((profile[key] != undefined && profile[key].cn != undefined)?profile[key].cn:key):value.cn"
															style="width: 50%; display: inline-block;">{{ (value.cn == undefined?((profile[key] != undefined && profile[key].cn != undefined)?profile[key].cn:key):value.cn)}}<br />({{key}})</span>
														<Input style="width: 32%;" v-if="value.type == 'String'"
															v-model="paramSet[currentProfileName][key]" />
														<InputNumber
															v-if="value.type == 'Number' || value.type == 'Time'"
															style="width: 32%;" :active-change="false"
															v-model="paramSet[currentProfileName][key]"
															:min="value.min? (value.min - 0.01):undefined"
															:max="value.max? (value.max + 0.01):undefined" />
														<Select v-if="value.type == 'Select'"
															v-model="paramSet[currentProfileName][key]"
															style="width: 32%;">
															<Option v-for="item in value.data" :value="item.value"
																:key="item.value">{{ item.cn }}</Option>
														</Select>
														<label v-if="value.unit"
															style="margin-right: -41px;padding-left: 10px; width: 8%; display: inline-block;">{{ value.unit }}</label>
													</span>
												</v-row>
											</div>
										</Content>
									</Layout>
								</Content>
							</Layout>
						</Layout>
					</div>
				</div>
			</div>
			<div slot="footer">
				<Button v-show="currentDownStep > 0" type="info" size="large" @click="preStep">上一步</Button>
				<Button v-show="currentDownStep < 1" type="info" size="large" @click="nextStep">下一步</Button>
			</div>
		</Modal>

		<Modal title="Title" v-model="modal8" :mask-closable="false" width="380">
			<p slot="header" style="color:#0066FF;text-align:center">
				<Icon type="md-create" />
				<span>搜索</span>
			</p>
			<div style="text-align:center">
				<CheckboxGroup v-model="selectedCondition" class="check_grop">
					<div>
						<Checkbox label="deviceId">
							<span>设备MAC</span>
						</Checkbox>
						<Input v-model="deviceIdModel" placeholder="请输入设备MAC" style="width: 150px" />
					</div>
					<div>
						<Checkbox label="subType">
							<span>下发类型</span>
						</Checkbox>
						<Select v-model="subTypeModel" style="width:150px" placeholder="请选择命令字">
							<Option v-for="(value, key) in valveProfile['paramSet']"  :value="key"
								:key="key">{{value.cn}}</Option>
						</Select>
					</div>
					<div>
						<Checkbox label="timeStamp">
							<span>时间区间</span>
						</Checkbox>
						<Tooltip transfer placement="top"
							:disabled="timeStampModel == undefined || timeStampModel[0] == ''">
							<div slot="content">
								<span>{{dateFtt('yyyy-MM-dd hh:mm:ss',timeStampModel[0])}}</span>
								<br />
								<span style="margin-left:50%">~</span>
								<br />
								<span>{{dateFtt('yyyy-MM-dd hh:mm:ss',timeStampModel[1])}}</span>
							</div>
							<DatePicker v-model="timeStampModel" type="daterange" split-panels placeholder="请选择时间区间"
								style="width: 150px"></DatePicker>
						</Tooltip>
					</div>
				</CheckboxGroup>
			</div>
			<div slot="footer">
				<Button icon="md-search" type="info" size="large" long @click="searchByCondition">检索</Button>
			</div>
		</Modal>
	</div>
</template>

<script>
	import {
		constants
	} from "crypto";
	export default {
		name: "meter_box_down",
		data() {
			let that = this;
			return {
        visibleDialog: {
          currentPage: 1,
          pageSize: 15
        },
        toggleLock: false,
        filterValve: '',
        allValvesNo: [],
        tableDate: [],
				valveProfile: {},
				valveDownProfile: {},
				columns1: [{
						title: "编号",
						key: "id",
						align: "center",
						sortable: true
					},
					{
						title: "设备编号",
						key: "num",
						align: "center",
						sortable: true
					},
					{
						title: "类型",
						align: "center",
						sortable: true,
						render: function(h, params) {
							return h(
								"div",
								that.valveProfile[params.row.mainType][params.row.subType].cn
							);
						}
					},
					{
						title: "下发日期",
						sortable: true,
						align: "center",
						render: function(h, params) {
							try {
								// if (params.row.messageHappentimestamp != undefined) {
								//   let timeStr = global.dateFtt(
								//     "yyyy-MM-dd hh:mm:ss",
								//     new Date(params.row.messageHappentimestamp)
								//   );
								//   return h("div", timeStr == "" ? "设备未校时" : timeStr);
								// } else {
								return h(
									"div",
									global.dateFtt(
										"yyyy-MM-dd hh:mm:ss",
										new Date(params.row.happenTime)
									)
								);
								// }
							} catch (err) {
								return h("div", "JSON格式错误");
							}
						}
					},
					{
						title: "接收日期",
						sortable: true,
						align: "center",
						render: function(h, params) {
							return h(
								"div",
								global.dateFtt(
									"yyyy-MM-dd hh:mm:ss",
									new Date(params.row.receiveTime)
								)
							);
						}
					},
					{
						title: "状态",
						slot: "status",
						align: "center"
					},
					{
						title: "数据集",
						slot: "action",
						align: "center",
						width: 80
					}
				],
				reloadMessage: {},
				data1: [],
				loading: true,
				showDrawer: false,
				selectDataHtml: "",
				selectData: {},
				modal8: false,
				totalRows: 0,
				pageSize: 30,
				selectedCondition: [],
				commandEnum: global.valveMessageTypeEnum2,
				valvesEnum: {},
				saveIdModel: "",
				deviceIdModel: "",
				mainTypeModel: "",
				subTypeModel: "",
				commandIdModel: "",
				timeStampModel: "",
				pageNo: 1,
				requestBody: {},
				showDown: false,
				currentDownStep: 0,
				valvesNo: [],
				// selectedValve: "",
				selectValveArray: [],
				paramSet: {},
				selectedDownValve: "",
				currentProfileName: ""
			};
		},
		created() {
			this.getBoxProfile();
			this.request();
		},
		mounted() {
		},
		methods: {
			gotoContent(name, params) {
				this.currentProfileName = name;
			},
			reloadDown(type) {
				if (this.selectedDownValve == "" || this.selectedDownValve == undefined) {
					this.$Notice.error({
						title: "异常",
						desc: "请选择载入设备号"
					});
					return;
				}
				var that = this;
				this.pageNo = 1;
				$.ajax({
					url: "/api/valve/getLastDownValve",
					contentType: "application/json",
					type: "post",
					data: JSON.stringify({
						messageMac: that.selectedDownValve,
						messageMaintype: "paramSet",
						messageSubtype: type
					}),
					dataType: "json",
					success: function(data) {
						if (data.errorCode != 0) {
							that.$Notice.error({
								title: "异常",
								desc: data.errorInfo
							});
							return;
						}
						let body = data.body;
						if (body.length == 0) {
							that.reloadMessage[type] =
								"无历史下发" + type + "类型数据故无法载入";
						} else {
							let lastDown = body[0];
							let timestamp = global.dateFtt(
								"yyyy-MM-dd hh:mm:ss",
								new Date(lastDown.messageReceivetimestamp)
							);
							let downContent = JSON.parse(lastDown.messageContent);
							Object.keys(downContent).forEach(function(key) {
								that.paramSet[type][key] = downContent[key];
							});
							that.reloadMessage[type] =
								"已载入" + timestamp + "下发的" + type + "数据";
							that.$forceUpdate();
						}
						that.$Notice.info({
							title: "提示",
							desc: that.reloadMessage[type]
						});
						that.loading = false;
					},
					error: function() {
						that.loading = false;
						that.$Notice.error({
							title: "异常",
							desc: "接口请求异常"
						});
					}
				});
			},
			preStep() {
				this.currentDownStep = this.currentDownStep - 1;
			},
			nextStep(type) {
				var that = this;
				if (that.currentDownStep == 0) {
					if (that.selectValveArray.length == 0) {
						that.$Notice.info({
							title: "提示",
							desc: "请至少添加一个设备"
						});
					} else {
						that.currentDownStep = that.currentDownStep + 1;
						Object.keys(that.reloadMessage).forEach(function(key) {
							that.reloadMessage[key] = "";
						});
					}
				} else if (that.currentDownStep == 1) {
					that.$Modal.confirm({
						title: "操作确认",
						content: "确认进行下发操作？",
						onOk: () => {
							that.downMessage(type);
							that.currentDownStep = 0;
							that.showDown = false;
							Object.keys(that.valveProfile.paramSet).forEach(function(
								profileName
							) {
								let profile = that.valveProfile.paramSet[profileName].params;
								let temp = {};
								Object.keys(profile).forEach(function(key) {
									temp[key] = profile[key].default ? profile[key].default :
										profile[key].min;
								});
								
								that.paramSet[profileName] = temp;
								that.reloadMessage[profileName] = "";
							});
						},
						onCancel: () => {}
					});
				}
			},
			handleClose(item) {
        this.selectValveArray = this.selectValveArray.filter(res => res !== item);
        this.$refs.multipleTable.toggleRowSelection(item);
				// this.selectValveArray.pop(item);
			},
			dateFtt(fmt, date) {
				return global.dateFtt(fmt, new Date(date));
			},
			request() {
				var that = this;
				if (localStorage.getItem("isAdmin") != "true") {
					that.requestBody["companyNum"] = localStorage.getItem("personnelGroverningBodyId");
				}
				that.pageNo = 1;
				$.ajax({
					url: "/api/alarm/admin/buildingmessage/getBuildingParamSetList?currentPage=" +
						that.pageNo +
						"&pageSize=" +
						that.pageSize +
						"&paging=true",
					data: that.requestBody,
					success: function(result) {
						if (!result.success) {
							that.$Notice.error({
								title: "异常",
								desc: result.msg
							});
							return;
						}
						that.data1 = result.data.list;
						that.totalRows = result.data.totalRows;
					},
					error: function() {
						that.$Notice.error({
							title: "异常",
							desc: "接口请求异常"
						});
					},
					complete: function() {
						that.loading = false;
					}
				});
			},

			ok() {},
			cancel() {},
			del() {},
			// 修改页面容量
			changePageSize(pageSize) {
				this.pageSize = pageSize;
				this.request();
			},
			// 修改
			getValvesNo() {
				var that = this;
				that.loading = true;
				$.ajax({
					url: "/api/alarm/admin/buildingmessage/getList",
					contentType: "application/json",
					type: "get",
					dataType: "json",
					data: that.requestBody,
					success: function(result) {
						if (!result.success) {
							that.$Notice.error({
								title: "异常",
								desc: result.msg
							});
							return;
						}
            that.allValvesNo = JSON.parse(JSON.stringify(result.data));
            that.paginate()
						let valvesEnum = {};
						for (let i = 0; i < result.data.list.length; i++) {
							let temp = result.data.list[i];
							valvesEnum[temp.valveBaseMac] = temp.valveBaseNumber;
						}
						that.valvesEnum = valvesEnum;
					},
					error: function() {
						that.$Notice.error({
							title: "异常",
							desc: "接口请求异常"
						});
					},
					complete: function() {
						that.loading = false;
					}
				});
			},
			// 修改
			changePage(index) {
				var that = this;
				if (localStorage.getItem("isAdmin") != "true") {
					that.requestBody["companyNum"] = localStorage.getItem(
						"personnelGroverningBodyId"
					);
				}
				that.pageNo = index;
				that.loading = true;
				// that.pageNo = 1;
				$.ajax({
					url: "/api/alarm/admin/message/getParamSetList?currentPage=" +
						that.pageNo +
						"&pageSize=" +
						that.pageSize +
						"&paging=true",
					data: that.requestBody,
					success: function(result) {
						if (!result.success) {
							that.$Notice.error({
								title: "异常",
								desc: result.msg
							});
							return;
						}

						that.data1 = result.data.list;
						that.totalRows = result.data.totalRows;
					},
					error: function() {
						that.$Notice.error({
							title: "异常",
							desc: "接口请求异常"
						});
					},
					complete: function() {
						that.loading = false;
					}
				});
			},
			// 按条件检索点击事件
			searchByCondition() {
				this.requestBody = {};
				var keys = Object.keys(this.valveProfile['paramSet']);
				console.log(keys);
				for (var temp in this.selectedCondition) {
					if (this.selectedCondition[temp] == "subType") {
						if (this.subTypeModel == "") {
							continue;
						}
						this.requestBody["subType"] = this.subTypeModel;
					}
					if (this.selectedCondition[temp] == "deviceId") {
						if (this.deviceIdModel == "") {
							continue;
						}
						this.requestBody["mac"] = this.deviceIdModel;
					}
					if (this.selectedCondition[temp] == "timeStamp") {
						this.requestBody["happenTimeBegin"] = this.timeStampModel[0];
						this.requestBody["happenTimeEnd"] = this.timeStampModel[1];
					}
				}
				if (localStorage.getItem("isAdmin") != "true") {
					this.requestBody["valveBaseRemark6"] = localStorage.getItem(
						"personnelGroverningBodyId"
					);
				}
				// 调用接口查询
				var that = this;
				that.loading = true;
				this.modal8 = false;
				this.pageNo = 1;
				$.ajax({
					url: "/api/alarm/admin/buildingmessage/getBuildingParamSetList?currentPage=" +
						that.pageNo +
						"&pageSize=" +
						that.pageSize +
						"&paging=true",
					data: that.requestBody,
					success: function(res) {
						that.$Notice.success({
							title: "提示",
							desc: "查询上传指令数据成功"
						});
						that.data1 = res.data.list;
						that.totalRows = res.data.totalRows;
						that.loading = false;
					},
					error: function() {
						that.loading = false;
						that.$Notice.error({
							title: "异常",
							desc: "接口请求异常"
						});
					}
				});
			},
			// selectValve() {
			// 	if (this.selectValveArray.indexOf(this.selectedValve) > -1) {
			// 		this.$Notice.info({
			// 			title: "提示",
			// 			desc: "请勿重复添加"
			// 		});
			// 	} else {
			// 		this.selectValveArray.push(this.selectedValve);
			// 	}
			// },
      selectValve(val) {
        this.selectValveArray = val
      },
      handleSizeChange(val) {
        this.visibleDialog.pageSize = val
        this.paginate()
      },
      handleCurrentChange(val) {
        this.visibleDialog.currentPage = val
        this.paginate()
      },
      paginate() {
        // 计算起始索引
        const startIndex = (this.visibleDialog.currentPage - 1) * this.visibleDialog.pageSize;
        // 计算结束索引
        const endIndex = startIndex + this.visibleDialog.pageSize;
        // 从数据数组中截取出当前页的数据
        this.valvesNo = this.allValvesNo.filter(item => new RegExp(this.filterValve, 'i').test(item.num))
        this.tableDate =  this.valvesNo.slice(startIndex, endIndex);
      },
			getValveDownProfile() {
				// 调用接口查询
				var that = this;
				that.loading = true;
				$.ajax({
					url: "/api/valve/getSafetyValveDownProfile",
					contentType: "application/json",
					type: "get",
					dataType: "json",
					success: function(data) {
						if (data.errorCode == 0) {
							that.valveDownProfile = data.body;
							Object.keys(that.valveDownProfile).forEach(function(profileName) {
								let profile = that.valveDownProfile[profileName];
								let temp = {};
								Object.keys(profile).forEach(function(key) {
									temp[key] = profile[key].default;
								});
								that.paramSet[profileName] = temp;
								that.reloadMessage[profileName] = "";
							});
							//   that.loading = false;
						} else {
							that.$Notice.error({
								title: "异常",
								desc: data.errorInfo
							});
						}

						that.loading = false;
					},
					error: function() {
						that.loading = false;
						that.$Notice.error({
							title: "异常",
							desc: "接口请求异常"
						});
					}
				});
			},
			downMessage(type) {
				var that = this;
				let downParams = {};
				downParams[type] = {};
        const selectMac = this.selectValveArray.map(item => item.mac)
				let params = that.valveProfile.paramSet[type].params;
				Object.keys(params).forEach(function(key) {
					downParams[type][key] = (params[key].default ? params[key].default : params[key].min) + "";
					if (that.paramSet[type][key] != undefined && that.paramSet[type][key] != "") {
						downParams[type][key] = that.paramSet[type][key] + "";
					}
				});
				$.ajax({
					url: "/api/alarm/admin/buildingmessage/down",
					type: "post",
					data: {
						macList: selectMac,
						content: JSON.stringify(downParams[type]).toString(),
						mainType: "paramSet",
						subType: type,
						state: 0
					},
					success: function(result) {
						if (!result.success) {
							that.$Notice.error({
								title: "异常",
								desc: result.msg
							});
							return;
						}

						that.$Notice.success({
							title: "提示",
							desc: "下发成功等待设备获取"
						});
						that.request();
					},
					error: function() {
						that.$Notice.error({
							title: "异常",
							desc: "网络异常"
						});
					},
					complete: function() {
						that.loading = false;
					}
				});
			},
			getBoxProfile() {
				// 调用接口查询
				var that = this;
				that.loading = true;
				$.ajax({
					url: "/api/alarm/admin/buildingmessage/getProfile",
					success: function(result) {
						if (!result.success) {
							that.$Notice.error({
								title: "异常",
								desc: result.msg
							});
							return;
						}

						that.valveProfile = result.data;
						Object.keys(that.valveProfile.paramSet).forEach(function(profileName) {
							let profile = that.valveProfile.paramSet[profileName].params;
							if (profile == undefined) {
								return;
							}
							let temp = {};
							Object.keys(profile).forEach(function(key) {
								temp[key] = profile[key].default;
							});
							that.paramSet[profileName] = temp;
							that.reloadMessage[profileName] = "";
						});
					},
					error: function() {
						that.$Notice.error({
							title: "异常",
							desc: "网络异常"
						});
					},
					complete: function() {
						that.loading = false;
					}
				});
			},
			// 显示条件检索页面
			searchByConditionsView() {
				this.modal8 = true;
			},
			handleClose2(event, name) {
				const index = this.count.indexOf(name);
				this.count.splice(index, 1);
			},
			convertData(data, type, enums) {
				let result = data;
				if ("Time" == type) {
					result = global.dateFtt("yyyy-MM-dd hh:mm:ss", new Date(data * 1000));
				} else if ("Enum" == type) {
					result = enums[data] == undefined ? data : enums[data];
				}
				return result;
			},
			// 点击事件：点击显示数据集
			showData(row, index) {
				// 遍历数据集拼接HTML
				var htmlStr = "";
				var _this = this;

				let mainType = row.mainType;
				let subType = row.subType;

				try {
					htmlStr =
						"<table style='border:1px solid #C0C0C0; text-align: center;width: 100%; table-layout:fixed;'>";
					var amount = 0;
					let dataObject = JSON.parse(row.content);
					var data;
					data = dataObject;
					Object.keys(data).forEach(function(key) {
						if (amount % 2 == 0) {
							htmlStr += "<tr >";
						}
						htmlStr +=
							"<td style='margin-top:2px; border: 1px solid #C0C0C0;word-wrap:break-word;'>" +
							(_this.valveProfile[mainType] == undefined ||
								_this.valveProfile[mainType][subType] == undefined ||
								_this.valveProfile[mainType][subType]["params"][key] == null ?
								key :
								_this.valveProfile[mainType][subType]["params"][key].cn) +
							"</td><td style='margin-top:2px; border: 1px solid #C0C0C0;word-wrap:break-word;'>" +
							_this.convertData(
								data[key],
								_this.valveProfile[mainType][subType]["params"][key] == undefined ?
								"" :
								_this.valveProfile[mainType][subType]["params"][key].type,
								_this.valveProfile[mainType][subType]["params"][key] == undefined ?
								"" :
								_this.valveProfile[mainType][subType]["params"][key].enum
							) +
							(_this.valveProfile[mainType] == undefined ||
								_this.valveProfile[mainType][subType] == undefined ?
								"" :
								" " +
								(_this.valveProfile[mainType][subType]["params"][key] ==
									undefined ?
									"" :
									(_this.valveProfile[mainType][subType]["params"][key].unit == undefined ?
										"" : _this.valveProfile[mainType][subType]["params"][key].unit))) +
							"</td>";
						if (amount % 2 == 1) {
							htmlStr += "</tr>";
						}
						amount++;
					});

					htmlStr += "</table>";
					_this.selectDataHtml = htmlStr;
					_this.selectData = data;
				} catch (err) {
					_this.selectDataHtml = "<div>JSON格式错误</div>";
					_this.selectData = row.content;
					htmlStr = _this.selectDataHtml;
				}
				// this.showDrawer = true;

				var that = this;
				this.$Notice.open({
					title: "存储编号:" + row.id + "\t设备编号:" + row.num,
					// desc: htmlStr,
					render: h => {
						return h("div", {
							on: {},
							style: {
								height: "100%",
								width: "100%"
							},
							domProps: {
								innerHTML: htmlStr
							}
						});
					},
					duration: 20
				});
			}
		}
	};
</script>

<style>
	.ivu-notice-notice {
		width: 500px;
		right: 160px;
	}

	.query_condition {
		border: 1px solid #c0c0c0;
		padding: 2px;
		margin: 2px;
		border-radius: 5%;
	}

	.check_grop div {
		margin-bottom: 1px;
	}

	.ivu-modal {
		top: 20px;
	}

	.ivu-layout-sider::-webkit-scrollbar {
		width: 0;
	}

	.param-menu {
		height: 370px;
		overflow-y: scroll;
	}

	.param-menu::-webkit-scrollbar {
		width: 5px;
	}

	.param-menu::-webkit-scrollbar-thumb {
		border-radius: 10px;
		-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		background: lightgray;
	}

	.param-menu::-webkit-scrollbar-track {
		-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		border-radius: 10px;
	}

	.param-content {
		height: 280px;
		overflow-y: scroll;
	}

	.param-content::-webkit-scrollbar {
		width: 5px;
	}

	.param-content::-webkit-scrollbar-thumb {
		border-radius: 10px;
		-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		background: lightgray;
	}

	.param-content::-webkit-scrollbar-track {
		-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		border-radius: 10px;
	}
</style>
